"use strict";

require("core-js/modules/es.array.iterator");

var go1 = require("./go1.js");

var not = require("./not.js");

module.exports = negate;

function negate(f) {
  return (..._) => go1(f(..._), not);
}